import request from '../services/request';
import { baseURL } from '@/config';

export const getAll = () => request.get('/analytics');

async function sendAnalyticsEvent(url, payload) {
  try {
    let isSendBeaconSucceed = false;

    if (navigator.sendBeacon) {
      const headers = { type: 'application/json' };
      const blob = new Blob([JSON.stringify(payload)], headers);

      try {
        isSendBeaconSucceed = navigator.sendBeacon(url, blob);
      } catch (err) {
        // a basic post request will be sent below in case of any errors
      }
    }

    if (!isSendBeaconSucceed) {
      await request.post(url, payload);
    }
  } catch (e) {
    console.error('Failed to send statistics');
  }
}

export const pushEvent = async (userId, rawEventName, data = {}, forceReferrer) => {
  const referrer = forceReferrer || document.referrer;
  const payload = {
    referrer,
    rawEventName,
    data,
  };
  const url = `${baseURL}/analytics/push/${userId}`;

  await sendAnalyticsEvent(url, payload);
};

export const createEvent = async (payload) => {
  const url = `${baseURL}/analytics/event`;

  await sendAnalyticsEvent(url, payload);
};
